export enum BmarkOrderDataEventSource {
  OrderLifeCycleEvent,
  XferEvent,
  BmarkLockLifeCycleEvent,
  BulkOrderLifeCycleEvent,
  InterventionEvent,
  NettingEvent,
}

export namespace BmarkOrderDataEventSource {
  let elements = [
    BmarkOrderDataEventSource.OrderLifeCycleEvent,
    BmarkOrderDataEventSource.XferEvent,
    BmarkOrderDataEventSource.BmarkLockLifeCycleEvent,
    BmarkOrderDataEventSource.BulkOrderLifeCycleEvent,
    BmarkOrderDataEventSource.InterventionEvent,
    BmarkOrderDataEventSource.NettingEvent,
  ];
  let alias = "com.bcdfx.model.BmarkOrderDataUpdateSource";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
